// Constants
// Controls
import { FluentProvider } from "@fluentui/react-components";
import { PortalCompatProvider } from "@fluentui/react-portal-compat";
// Hooks
import { useV9Theme } from "../hooks/useUnoTheme";
// Utilities
import React from "react";
import { getRTL } from "@fluentui/utilities";
/**
 * Wrapper component that provides the Uno theme to the wrapped component.
 * @param Component to wrap with FluentProvider
 */ export const UnoThemeProvider = ({ unoTheme, children })=>{
    const v9Theme = useV9Theme(unoTheme);
    return /*#__PURE__*/ React.createElement(FluentProvider, {
        theme: v9Theme,
        dir: getRTL() ? "rtl" : "ltr"
    }, /*#__PURE__*/ React.createElement(PortalCompatProvider, null, children));
};
